import {Image, Linking, Text, TouchableOpacity, View} from "react-native";
import React, {memo} from "react";
import styles from "./styles";
import {Placeholder, PlaceholderLine, PlaceholderMedia, Shine} from "rn-placeholder";
import FontAwesome5 from "react-native-vector-icons/FontAwesome5";
import {useDispatch} from "react-redux";

function Offer (props) {
    const onURLPress = async (link) => {
        await Linking.openURL(link)
    }


    if(props.loading){
        return(
            <Placeholder Animation={Shine}>
                <View style={styles.listContent}>
                <View style={{flexDirection:"row"}}>
                    <View style={styles.listContentLeft}>
                        <PlaceholderMedia style={[styles.listImage]} />
                    </View>
                    <View style={styles.listContentRight}>
                        <View>
                            <PlaceholderLine width={70} />
                            <PlaceholderLine />
                            <PlaceholderLine />
                        </View>
                    </View>
                </View>
                <View style={{flexDirection:"row",marginTop:10}}>
                    <View style={{flex:3,flexDirection:"row"}}>
                        <View style={{flex:1,marginLeft:"30%"}}>
                            <PlaceholderLine />
                        </View>
                    </View>
                </View>
            </View>
        </Placeholder>
        )
    } else {
        return(
            <View style={styles.listContent}>
                <View style={{flexDirection:"row"}}>
                    <View style={[styles.listContentLeft,{height:'80px'}]}>
                        <Image source={{uri: props.imgsrc}}  style={[styles.listImage,styles.listImageBorder]} />
                    </View>
                    <View style={styles.listContentRight}>
                        <View style={{flexDirection:"row", justifyContent:"space-between"}}>
                            <Text numberOfLines={1} style={styles.listContentTitle}>
                                {props.name}
                            </Text>
                            <TouchableOpacity  onPress={() => props.favouriteFunction(props.index)} style={{marginBottom:4}}>
                                {props.Favourite ? <View style={styles.iconFull}>
                                    <FontAwesome5
                                        name={'star'}
                                        size={14}
                                        color={props.appData.theme_colour}
                                        type="FontAwesome5"
                                        solid
                                    />
                                </View> : <View style={styles.iconFull}>
                                    <FontAwesome5
                                        name={'star'}
                                        size={14}
                                        color="black"
                                        type="FontAwesome5"
                                    />
                                </View> }
                            </TouchableOpacity>
                        </View>
                        <View style={{flexDirection:"column"}}>
                            <Text numberOfLines={3} style={styles.listContentBody}>
                                {props.description}
                            </Text>
                            <TouchableOpacity  onPress={() => props.showOffer(props)}>
                                <Text style={styles.readMore}>...more</Text>
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>
                <View style={{flexDirection:"row",marginTop:10, flex:"1"}}>
                    <View style={{flex:1, flexDirection:"row"}}>
                        <View style={{flex:1}}></View>
                        <View style={{flex:3, alignItems:"end"}}>
                            <TouchableOpacity onPress={() => onURLPress(props.link)} style={{width:"100%"}}>
                                <Text style={[styles.shopNow,{color:props.appData.theme_colour, borderColor: props.appData.theme_colour}]}>Shop Now</Text>
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>
            </View>
        )
    }
}

export default memo(Offer);


